export default __webpack_public_path__ + "static/media/roadmap-bg-min.86d0e335.png";